export default __webpack_public_path__ + "static/media/chevron-right.af82c730.svg";